import { render, staticRenderFns } from "./DetailExperienceForm.vue?vue&type=template&id=035497fe&scoped=true"
import script from "./DetailExperienceForm.vue?vue&type=script&lang=js"
export * from "./DetailExperienceForm.vue?vue&type=script&lang=js"
import style0 from "./DetailExperienceForm.vue?vue&type=style&index=0&id=035497fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035497fe",
  null
  
)

export default component.exports